import React, { useState, useEffect } from "react";
import { firestore } from "../../../components/firebase/FirebaseProvider";
import { useData } from "../../../components/firebase/DataProvider";
import {
  arrayToCurrencyString,
  arrayToCurrencyStringPromo,
  calculateHargaLevel,
} from "../../../utils/currency";
import { findOnePromo } from "../../../utils/promo";
import { analytics } from "../../../components/firebase/FirebaseProvider";
import { useHistory } from "react-router-dom";
import slugify from "slugify";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import Paper from "@material-ui/core/Paper";
import useStyles from "./style/flashSaleStyle";
import ScrollContainer from "react-indiana-drag-scroll";
import Button from "@material-ui/core/Button";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import {
  Card,
  Typography,
  CardActionArea,
  Divider,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import DialogNewProduk from "./dialogNewProduk";
import { upperFirst } from "lodash";

function PreOreder() {
  const classes = useStyles();
  const history = useHistory();
  const [products, setProducts] = useState([]);
  // const [slicedProducts, setSlicedProducts] = useState([]);
  // const [expiration_date, setExpire] = useState();
  // const [keywords, setKeywords] = useState([]);
  // const { seconds } = useCountDownTimer(expiration_date);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const { level, promo, global_komisi } = useData();
  // const time = new Date();
  // const timeSeconds = Math.round(time.getTime() / 1000);
  // console.log("time", timeSeconds);
  // console.log(products);

  const theme = useTheme();

  const miniScreen = useMediaQuery(theme.breakpoints.down("960"));

  useEffect(() => {
    async function getProducts() {
      setLoading(true);
      try {
        // console.log("LEWAT");
        const productsRef = firestore.collection("products");
        const query = await productsRef
          .where("sembunyikan_produk", "==", false)
          .where("properties.type", "==", "preorder")
          .where(
            "properties.end_at",
            ">",
            new Date(Date.now() - 60 * 60 * 1000)
          )
          .get();
        if (!query.empty) {
          const newProducts = await Promise.all(
            query.docs.map(async (product) => {
              const variants = await product.ref
                .collection("variants")
                .where(`harga_normal`, ">", 0)
                .get();
              return {
                id: product.id,
                ...product.data(),
                variants: variants.docs.map((variant) => {
                  return {
                    id: variant.id,
                    ...variant.data(),
                  };
                }),
              };
            })
          );
          const filteredProducts = newProducts.filter((product) => {
            const stok = product?.variants?.map(
              (variant) => variant?.stok_available
            );
            const total_stok = stok?.reduce((val, nilaiSekarang) => {
              return val + nilaiSekarang;
            }, 0);
            return product.variants.length > 0 && total_stok > 0;
          });
          setProducts(filteredProducts);
        }
        setLoading(false);
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    }
    getProducts();
  }, []);

  const toDetailProduct = (id, title) => () => {
    // console.log("to detail...");
    analytics.logEvent("view_product", { name: title, id: id });

    history.push(`/produk/${slugify(title.toLowerCase())}/${id}`);
  };

  // console.log(!loading && products.length > 0, loading, products.length > 0);

  return !loading && products.length > 0 ? (
    <Paper elevation={0} className={classes.container}>
      <Divider
        style={{
          height: 5,
          marginLeft: -10,
          marginRight: -10,
          backgroundColor: "#efefef",
        }}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 15,
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ marginRight: "10px" }}>
            <Typography
              style={{
                fontSize: "13px",
                fontWeight: "bold",
                textTransform: "uppercase",
              }}
            >
              Pre Order ✨
            </Typography>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Button
            size="small"
            endIcon={<ArrowRightIcon color="primary" />}
            onClick={() => setOpen(true)}
          >
            <Typography color="primary" style={{ fontSize: "11px" }}>
              Lihat semua
            </Typography>
          </Button>
        </div>
      </div>
      <ScrollContainer className={classes.wrapperPreorder}>
          {products?.map((item, index) => {
            const stok = item?.variants?.map(
              (variant) => variant?.stok_available
            );

            const productValue =
              item?.product_value !== undefined &&
              item?.product_value !== "" &&
              !Number.isNaN(item?.product_value) &&
              item?.product_value >= 0
                ? item?.product_value
                : 1;

            const harga = item?.variants?.map((variant) =>
              calculateHargaLevel(
                variant?.harga_normal,
                global_komisi,
                level?.level,
                productValue
              )
            );

            const harga_normal = item?.variants.map(
              (variant) => variant?.harga_normal
            );

            const promoFound = findOnePromo(item, promo);

            const total_stok = stok.reduce((val, nilaiSekarang) => {
              return val + nilaiSekarang;
            }, 0);

            const emptyStock = total_stok === 0 ? true : false;

            const harga_str = arrayToCurrencyString(harga);
            const promoF = promoFound ? true : false;

            const harga_str_promo =
              promoFound &&
              arrayToCurrencyStringPromo(
                harga_normal,
                promoFound,
                level.level,
                global_komisi,
                productValue
              );

            const textBadgePromo = (() => {
              let text = "";

              if (promoFound) {
                if (promoFound?.tipe === "%") {
                  text = `${promoFound?.nilai}%`;
                } else {
                  text = `${promoFound?.nilai / 1000}K`;
                }
              }

              return text;
            })();
            if (index < 5) {
              return (
                <div className={classes.wrapper} key={index}>
                  <Card
                    className={classes.card}
                    onClick={toDetailProduct(item.id, item.nama)}
                  >
                    <CardActionArea>
                      {promoF && !emptyStock ? (
                        <div className={classes.label}>
                          <Typography className={classes.txtLabel}>
                            {textBadgePromo}
                          </Typography>
                          <Typography className={classes.txtLabel}>
                            OFF
                          </Typography>
                        </div>
                      ) : null}
                      {emptyStock ? (
                        <div className={classes.empty}>
                          <span className={classes.txtEmpty}>Stok Habis</span>
                        </div>
                      ) : null}
                      {item.thumbnail?.length > 0 ? (
                        <div
                          loading="lazy"
                          // src={item.thumbnail[0]}
                          // alt={item.id}
                          className={classes.img}
                          style={{
                            backgroundImage: `url(${item.thumbnail[0]})`,
                          }}
                        />
                      ) : (
                        <div
                          loading="lazy"
                          // src={item.thumbnail}
                          // alt={item.id}
                          className={classes.img}
                          style={{
                            backgroundImage: `url(${item.thumbnail})`,
                          }}
                        />
                      )}
                    </CardActionArea>
                    <div className={classes.contentWrapper}>
                      <div className={classes.content}>
                        <div style={{ display: "flex" }}>
                          {promoFound?.flash_sale ||
                          promoFound?.special_offer ? (
                            <div className={classes.labelFlash}>
                              {promoFound?.flash_sale
                                ? "Flashsale"
                                : "Special Offer"}
                            </div>
                          ) : null}
                          {item?.properties?.type === "preorder" && (
                            <div className={classes.labelPre}>Pre Order</div>
                          )}
                          {item?.new_arrival?.seconds * 1000 > Date.now() ? (
                            <div className={classes.labelNew}>Baru</div>
                          ) : null}
                        </div>{" "}
                        <Typography className={classes.title} component="p">
                          {item?.nama}
                        </Typography>
                        <div>
                          {item?.properties?.type === "preorder" ? (
                            ""
                          ) : (
                            <>
                              <Typography
                                className={classes.txtStockTersedia}
                                component="p"
                              >
                                Stok tersedia
                              </Typography>
                              <Typography
                                className={classes.txtStock}
                                component="p"
                              >
                                {total_stok > 100 ? "99+" : total_stok} pcs
                              </Typography>
                            </>
                          )}
                        </div>
                        <Typography
                          className={classes.txtLabelharhag}
                          component="p"
                        >
                          Harga {upperFirst(level.level)}
                        </Typography>
                        <Typography className={classes.price} component="p">
                          {promoFound ? harga_str_promo : harga_str}
                        </Typography>
                        <div className={classes.labelKomisi}>
                          {Math.round(
                            global_komisi?.[level?.level] * productValue * 100
                          )}
                          % Komisi
                        </div>
                        {/* <div
                        style={{
                          position: "absolute",
                          right: 5,
                          zIndex: "0",
                        }}
                      >
                        <NewFeatureIcon width={32} height={32} />
                      </div> */}
                      </div>
                      <div className={classes.btnWrap}>
                        {emptyStock ? (
                          <Button
                            fullWidth
                            variant="contained"
                            color="secondary"
                            size="small"
                            className={classes.btn}
                            style={{
                              backgroundColor: "rgb(255, 107, 107)",
                            }}
                          >
                            Stok Habis
                          </Button>
                        ) : (
                          <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            size="small"
                            className={classes.btn}
                            onClick={toDetailProduct(item?.id, item?.nama)}
                          >
                            Beli
                          </Button>
                        )}
                      </div>
                    </div>
                  </Card>
                </div>
              );
            }
            return null;
          })}
          {products?.length > 3 ? (
            <div
              style={{
                alignSelf: "center",
                paddingLeft: 37.5,
                paddingRight: 37.5,
              }}
              onClick={() => setOpen(true)}
            >
              <div style={{ width: 80 }}>
                <PlayCircleOutlineIcon
                  color="primary"
                  style={{ width: "100%", fontSize: 27.5 }}
                />
                <Typography
                  style={{ fontSize: 12.5, marginTop: 10 }}
                  align="center"
                >
                  Lihat Semua
                </Typography>
              </div>
            </div>
          ) : null}
      </ScrollContainer>
      <DialogNewProduk
        open={open}
        handleClose={() => setOpen(false)}
        data={products}
        mode="Pre Order"
      />
    </Paper>
  ) : null;
}

export default PreOreder;
